import React, { useState } from 'react'
import {
  Alert,
  AlertDescription,
  AlertIcon,
  Button,
  Checkbox,
  HStack,
  Stack,
  Text
} from '@chakra-ui/react'

import axios from 'lib/axios'

import InfoHint from '../components/InfoHint'
import { getErrorMessage } from '../types'

type Props = {
  statementEndDate: string
}

const UploadRecipientsBQ = ({ statementEndDate }: Props) => {
  const [isConfirmed, setIsConfirmed] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState('')
  const [result, setResult] = useState<any | null>(null)

  const onUpload = async () => {
    try {
      setIsLoading(true)
      setError('')
      setResult(null)
      const { data } = await axios.post('/admin/statements/recipients/upload', {
        statementEndDate
      })
      setResult(data)
    } catch (err: any) {
      setError(getErrorMessage(err))
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Stack spacing={3}>
      <HStack spacing={1} alignItems='center'>
        <Checkbox
          isChecked={isConfirmed}
          onChange={(event) => setIsConfirmed(event.target.checked)}
        >
          I confirm Snapshot &amp; Rebuild is complete
        </Checkbox>
        <InfoHint label='Recipient upload must use the same rebuilt final statements run you plan to send, so this checkpoint prevents stale audience snapshots.' />
      </HStack>
      <HStack spacing={1} alignSelf='flex-start' alignItems='center'>
        <Button
          colorScheme='teal'
          variant='solid'
          onClick={onUpload}
          isDisabled={!isConfirmed || isLoading || !statementEndDate}
          alignSelf='flex-start'
        >
          Upload Statement Recipients
        </Button>
        <InfoHint label='Creates statement_recipients.statements_YYYY_MM in BigQuery by subsetting final monthly_customer_statements to reviewed enabled rentals.' />
      </HStack>

      {error && (
        <Alert status='error'>
          <AlertIcon />
          <AlertDescription>{error}</AlertDescription>
        </Alert>
      )}

      {result && (
        <Alert status={result.mismatchCount === 0 ? 'success' : 'warning'}>
          <AlertIcon />
          <AlertDescription>
            Created {result.tableName} with {result.rowCount} rows (enabled={result.enabledCount},
            mismatch={result.mismatchCount}).
          </AlertDescription>
        </Alert>
      )}

      <HStack spacing={1} alignItems='center'>
        <Text>Expected table format: statement_recipients.statements_YYYY_MM</Text>
        <InfoHint label='This table is an auditable record of exactly which rentals were included in the monthly send cohort.' />
      </HStack>
    </Stack>
  )
}

export default UploadRecipientsBQ
